// Client-side rules for resale-certificate uploads, shared by the application
// form (ApplyPage) and the per-location resubmit flow on the pending wall
// (#198 / E5-S11). Mirrors the API's ApplicationValidation limits so the user
// is told before the round-trip.

export const MAX_FILE_BYTES = 10 * 1024 * 1024; // 10 MB

// Mirrors the API's ApplicationValidation:AllowedCertificateTypes. `image/jpg`
// is non-standard but the server accepts it, so it stays in the list.
export const ACCEPTED_FILE_TYPES = [
    "application/pdf",
    "image/jpeg",
    "image/jpg",
    "image/png",
];

export const CERTIFICATE_REQUIRED_MESSAGE = "A resale certificate is required";
export const CERTIFICATE_SIZE_MESSAGE = "File must be 10 MB or smaller";
export const CERTIFICATE_TYPE_MESSAGE = "Upload a PDF, JPG, or PNG file";

// Size/type check for a chosen certificate file. Returns the user-facing
// message for the first failing rule, or null when the file is acceptable.
// (Presence is the caller's concern — a File must already exist to be checked.)
export const certificateFileError = (file: File): string | null => {
    if (file.size > MAX_FILE_BYTES) {
        return CERTIFICATE_SIZE_MESSAGE;
    }

    if (!ACCEPTED_FILE_TYPES.includes(file.type)) {
        return CERTIFICATE_TYPE_MESSAGE;
    }

    return null;
};
